function initPicker() {
  const wrap = document.querySelector('[data-vt-picker]');
  if (!wrap || wrap.dataset.vtInit === '1') return;
  wrap.dataset.vtInit = '1';

  const merk = wrap.querySelector('[data-vt-merk]');
  const model = wrap.querySelector('[data-vt-model]');
  const knop = wrap.querySelector('[data-vt-go]');
  const uitslag = wrap.parentElement.querySelector('[data-vt-result]');

  const leeg = model.options[0]?.textContent || '';

  const zetLeeg = () => {
    model.innerHTML = '';
    model.disabled = true;
    model.add(new Option(leeg, ''));
  };

  const vul = (handle, catalogus) => {
    const modellen = (catalogus || {})[handle] || [];
    if (!handle || modellen.length === 0) return zetLeeg();

    model.innerHTML = '';
    model.disabled = false;
    model.add(new Option(model.dataset.vtChoose || '', ''));
    modellen.forEach((m, i) => {
      const o = new Option(m.naam, String(i));
      o.dataset.merk = handle;
      o.dataset.naam = m.naam;
      if (m.url) o.dataset.url = m.url;
      if (m.kw > 0) o.dataset.kw = String(m.kw);
      model.add(o);
    });
  };

  merk.addEventListener('change', () => {
    uitslag?.removeAttribute('data-show');
    const handle = merk.value;
    if (!handle) return zetLeeg();
    model.disabled = true;
    window.VTCatalogus.laad()
      .then((c) => { if (merk.value === handle) vul(handle, c); })
      .catch(zetLeeg);
  });

  const metUitvoering = (adres) => {
    const handle = model.dataset.kzVoor === `${merk.value}/${model.value}`
      ? model.dataset.kzUitvoering : '';
    if (!adres || !handle) return adres;
    const u = new URL(adres, window.location.origin);
    u.searchParams.set('uitvoering', handle);
    return u.pathname + u.search;
  };

  knop.addEventListener('click', () => {
    if (!merk.value) {
      merk.focus();
      return;
    }

    const gekozenModel = model.selectedOptions[0];
    const gekozenMerk = merk.selectedOptions[0];

    const doel = gekozenModel?.value
      ? metUitvoering(gekozenModel.dataset.url)
      : gekozenMerk.dataset.url;

    if (uitslag) {
      const kw = gekozenModel?.dataset.kw;
      const naam = gekozenModel?.value
        ? `${gekozenMerk.textContent.trim()} ${(gekozenModel.dataset.naam || gekozenModel.textContent).trim()}`
        : gekozenMerk.textContent.trim();
      const zin = (kw ? uitslag.dataset.metKw : uitslag.dataset.zonderKw) || '';
      uitslag.querySelector('span').textContent = zin
        .replace('[auto]', naam)
        .replace('[kw]', kw ? Number(kw).toLocaleString(document.documentElement.lang || undefined) : '');
      uitslag.setAttribute('data-show', '');
    }

    if (doel) {
      setTimeout(() => {
        window.location.href = doel;
      }, 600);
    }
  });
}

initPicker();
document.addEventListener('shopify:section:load', initPicker);
